import type { PostalCodeData } from "@app/api/(platform)/country/[country]/pincode/[pincode]/types";
import { ClientFetchService } from "@lib/helpers/clientFetchService";
import { type QueryClient } from "@tanstack/react-query";

type UsePostalCodeParams = {
    country: string;
    postalCode: string;
};

type QueryClientParams = {
    queryClient: QueryClient;
};

const fetchPostalCodes = async ({ country, postalCode }: UsePostalCodeParams) => {
    return await ClientFetchService.get<PostalCodeData>(
        `/api/country/${country}/pincode/${postalCode}`
    );
};

const getKey = (args: UsePostalCodeParams) => {
    const { country, postalCode } = args;
    return ["postalCode", country, postalCode];
};

export const getPostalCodeData = ({
    country,
    postalCode,
    queryClient,
}: UsePostalCodeParams & QueryClientParams) => {
    const key = getKey({ country, postalCode });
    const fetcher = () => fetchPostalCodes({ country, postalCode });
    const getAsync = async () =>
        queryClient.ensureQueryData({
            queryKey: key,
            queryFn: fetcher,
        });

    return getAsync();
};
